import React, { useState } from "react";
import { useMutation, useQuery } from "@apollo/client";
import * as R from "ramda";
import { Table } from "tabler-react";
import { useParams } from "react-router-dom";
import dayjs from "dayjs";
import gql from "graphql-tag";
import { useResource } from "../services/engine";
import EditZlecenie from "./EditZlecenie";
import { filterFunction, filterSum } from "./Zlecenia";
import { KwotaFilter } from "./AllZlecenia";

export default () => {
  const [editedId, setEditedId] = useState(false);

  const [districtFilter, setDistrictFilter] = useState({});
  const [bagtypeFilter, setBagtypeFilter] = useState({});
  const [driverFilter, setDriverFilter] = useState({});

  const [sumToTakeFilter, setSumToTakeFilter] = useState(false);
  const [sumTakenFilter, setSumTakenFilter] = useState(false);
  const [sumBankFilter, setSumBankFilter] = useState(false);

  const { day } = useParams();
  const { listData } = useResource(
    "orders",
    `
        id
        created_at
        priority
        bagGenre
        comment
        status
        delivery
        numbers
        bags
        sumToTake
        finish_date
        sumTaken
        sumBank
        additional
        driver {
          id
          name
        }
    
      `,
    `
        id
      `,
    {
      where: {
        status: {
          _in: ["Done"],
        },
        finish_date: {
          _gt: dayjs(day).startOf("day").format("YYYY-MM-DD HH:mm"),
          _lt: dayjs(day).endOf("day").format("YYYY-MM-DD HH:mm"),
        },
      },
      order: {
        created_at: "asc",
      },
    }
  );

  const { data } = useQuery(gql`
        query Comment {
            daycomments(where: {date: {_eq: "${dayjs(day).format(
              "YYYY-MM-DD"
            )}"}}) {
                comment
                driver {
                    name
                }
            }
        }
    `);

  const [deleteOrderMutation] = useMutation(gql`
    mutation DeleteOrder($id: uuid) {
      update_orders(where: { id: { _eq: $id } }, _set: { status: "Deleted" }) {
        affected_rows
      }
    }
  `);

  const deleteOrder = (id) => {
    deleteOrderMutation({
      variables: {
        id,
      },
    });
  };

  if (!data || !listData) return null;

  const districts = R.uniq(
    listData
      .map((el) => (el.delivery ? el.delivery.district : false))
      .filter((el) => el)
  );

  const bagTypes = ["LM", "OB", "BR", "PB", "PRV", "BIAŁY"];

  const drivers = R.uniq(
    listData
      .map((el) => (el.driver ? el.driver.name : false))
      .filter((el) => el)
  );

  const filteredData = listData
    .filter(filterFunction(bagtypeFilter, ["bagGenre"]))
    .filter(filterFunction(driverFilter, ["driver", "name"]))
    .filter(filterFunction(districtFilter, ["delivery", "district"]))
    .filter(filterSum(sumToTakeFilter, "sumToTake"))
    .filter(filterSum(sumTakenFilter, "sumTaken"))
    .filter(filterSum(sumBankFilter, "sumBank"));

  return (
    <div>
      {editedId && (
        <EditZlecenie
          close={() => setEditedId(false)}
          data={listData.find((el) => el.id === editedId)}
        />
      )}
      {data.daycomments.map((comment) => (
        <div>
          {comment.comment} - {comment.driver.name}
        </div>
      ))}
      <br />
      <br />
      <br />
      <br />

      <b>Rodzaje worków</b>
      <br />
      {bagTypes.map((genre) => (
        <label>
          <input
            type="checkbox"
            checked={bagtypeFilter[genre]}
            onChange={(e) =>
              setBagtypeFilter({
                ...bagtypeFilter,
                [genre]: e.target.checked,
              })
            }
          />
          &nbsp;{genre}&nbsp;&nbsp;&nbsp;
        </label>
      ))}
      <br />
      <b>Dzielnice</b>
      <br />
      {districts.map((district) => (
        <label>
          <input
            type="checkbox"
            checked={districtFilter[district]}
            onChange={(e) =>
              setDistrictFilter({
                ...districtFilter,
                [district]: e.target.checked,
              })
            }
          />
          &nbsp;{district}&nbsp;&nbsp;&nbsp;
        </label>
      ))}
      <b>Kierowcy</b>
      <br />
      {drivers.map((driver) => (
        <label>
          <input
            type="checkbox"
            checked={driverFilter[driver]}
            onChange={(e) =>
              setDriverFilter({
                ...driverFilter,
                [driver]: e.target.checked,
              })
            }
          />
          &nbsp;{driver}&nbsp;&nbsp;&nbsp;
        </label>
      ))}
      <br />
      <b>Do pobrania</b>
      <br />
      <KwotaFilter value={sumToTakeFilter} set={setSumToTakeFilter} />
      <br />
      <b>Pobrana</b>
      <br />
      <KwotaFilter value={sumTakenFilter} set={setSumTakenFilter} />
      <br />
      <b>Przelew</b>
      <br />
      <KwotaFilter value={sumBankFilter} set={setSumBankFilter} />
      <br />

      <Table>
        <Table.Header>
          <Table.ColHeader>Adres</Table.ColHeader>
          <Table.ColHeader>Kierowca</Table.ColHeader>
          <Table.ColHeader>Zlecenie</Table.ColHeader>
          <Table.ColHeader>Akcje</Table.ColHeader>
        </Table.Header>
        <Table.Body>
          {filteredData.map((order) => (
            <Table.Row
              style={{
                borderBottom: "3px solid black",
              }}
            >
              <Table.Col>
                {order.delivery.address}
                <br /> {order.delivery.postcode} {order.delivery.city}
                <br /> {order.delivery.phone}{" "}
              </Table.Col>
              <Table.Col>
                {order.driver && order.driver.name}
                <br /> {order.comment}
              </Table.Col>
              <Table.Col>
                {dayjs(order.finish_date).format("YYYY-MM-DD")}
                <br />
                {order.bags} {order.bagGenre}
                <br />
                {order.sumTaken}/{order.sumToTake}/{order.sumBank}
                <br />
                {order.additional}
                <br />
                {order.numbers ? Object.values(order.numbers).join(", ") : ""}
              </Table.Col>
              <Table.Col>
                <div
                  onClick={() => {
                    setEditedId(order.id);
                  }}
                >
                  Edit
                </div>
                <div
                  onClick={() => {
                    const confirmed = window.confirm("Na pewno?");
                    if (confirmed == true) {
                      deleteOrder(order.id);
                      alert("Usunięto");
                    } else {
                    }
                  }}
                >
                  Delete
                </div>
              </Table.Col>
            </Table.Row>
          ))}
        </Table.Body>
      </Table>
    </div>
  );
};
